import React, { memo } from 'react';
import { Stack, Typography } from 'investira.react.components';
import { validators } from 'investira.sdk';
import QuestaoCard from '../_components/QuestaoCard';

const AvaliacoesEditQuestoes = memo(props => {
  const {
    categorias = {},
    activeCategoryId,
    activeQuestionId,
    onSelect,
    questoes = [],
    questoesReferencia = questoes,
    revisoes = {},
    respostasGestor = {},
    onQuestionChange,
    revisorUsuarioId = null
  } = props;

  if (validators.isEmpty(activeCategoryId)) {
    return null;
  }

  const xSessaoAtual = categorias[activeCategoryId];
  if (validators.isEmpty(xSessaoAtual)) {
    return null;
  }

  return (
    <Stack gap={2}>
      <Stack>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="caption" color="textSecondary" sx={{ textTransform: 'uppercase' }}>
            Sessão {xSessaoAtual.sessao}
          </Typography>
        </Stack>
        <Typography variant="h5" color="textPrimary">
          {xSessaoAtual.label}
        </Typography>
      </Stack>
      <Stack gap={3}>
        {questoes.map((xQuestao, xIndex) => {
          const xIndexReferencia = questoesReferencia.findIndex(
            pQuestao => Number(pQuestao.id) === Number(xQuestao.id)
          );
          const xAliasIndex = xIndexReferencia >= 0 ? xIndexReferencia : xIndex;

          return (
            <QuestaoCard
              key={xQuestao.id}
              id={xQuestao.id}
              aliasId={`${xSessaoAtual.sessao}.${xAliasIndex + 1}`}
              data={xQuestao}
              onSelect={onSelect}
              activeQuestionId={activeQuestionId}
              value={revisoes[xQuestao.id] || {}}
              respostaGestor={respostasGestor[xQuestao.id] || {}}
              revisorUsuarioId={revisorUsuarioId}
              onChange={onQuestionChange}
            />
          );
        })}
      </Stack>
    </Stack>
  );
});

export default AvaliacoesEditQuestoes;
